// extracted by mini-css-extract-plugin
export var scrollArea = "_ng-0";